import * as React from 'react';
import { translate } from 'react-i18next';
import { ItemCardList } from 'components';
import * as c from 'models/constants';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import { IOrderItem } from 'models/orders/order';
import { IProductCardDataAction } from 'models/product/productcard';

interface IProps {
	items: IOrderItem[];
	currencyKey: number;
	getProductCard: (id: string, target: string) => IProductCardDataAction;
}

interface IOrderItemsItemCardList extends IItemCardList {
	currencyKey?: number;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class OrderItems extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { items, currencyKey } = this.props;

		items.sort((a, b) => {
			if (a.productName < b.productName) {
				return -1;
			}
			if (a.productName > b.productName) {
				return 1;
			}

			return 0;
		});

		const listProps: IOrderItemsItemCardList = {
			items,
			itemType: c.NODE_TYPE_ORDERCARD_ITEM_CARD,
			currencyKey,
			goToCard: (id: string, target: string) => this.props.getProductCard(id, target),
		};

		return <ItemCardList {...listProps} />;
	}
}

export { OrderItems };
